module.exports = __webpack_public_path__ + "img/header_icon1.28bfedf0.png";